import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './EarningsPortalCollaborations.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import Tooltip from '../General/Tooltip';

import { getPrettyPriceDisplay, getPrettyDate } from '../../Helpers/formatting';

const EarningsPortalCollaborations = props => {
  const { user, payoutsAreLoading } = props;

  const contracts = useMemo(() => {
    const { user } = props;
    const contracts = _.get(user, 'payouts.payout_summaries.contracts', []);
    const orderedItems = _.orderBy(contracts, item => new Date(item.completedAt), 'desc');
    return orderedItems.map(item => {
      const { statusDisplay, isLocked, isPaid } = item;
      return {
        ...item,
        statusDisplay: statusDisplay,
        infoTooltip: isPaid
          ? null
          : isLocked
          ? 'This collaboration payment is locked and will be paid to you at the end of the week.'
          : `This collaboration has not yet been paid by the brand, we guarantee payment after 30 days and will cover the payment at that point.`
      };
    });
  }, [user]);

  const getContractCompletionDate = contract => contract.activeDate || contract.closedDate;

  const hasMoreContracts = contracts.length > 5;
  const gridTemplateColumns = '1fr 3fr 1fr 1fr';
  const [contractsVisible, setContractsVisible] = useState(5);

  if (payoutsAreLoading || !contracts.length) return null;
  return (
    <div className='earnings-portal-collaborations-outer'>
      <div className='earnings-portal-collaborations-inner'>
        <div className='earnings-portal-section-header'>
          <div>
            <div className='earnings-portal-section-title'>Collaborations</div>
          </div>
        </div>

        <div className='earnings-portal-table'>
          <div className='earnings-portal-table-header' style={{ gridTemplateColumns }}>
            <div className='earnings-portal-table-cell'>Completed</div>
            <div className='earnings-portal-table-cell'>Title</div>
            <div className='earnings-portal-table-cell'>Amount Earned</div>
            <div className='earnings-portal-table-cell'>Status</div>
          </div>

          <div className='earnings-portal-table-body'>
            {contracts.slice(0, contractsVisible).map((contract, idx) => {
              const { title, id, brandName, amountEarned, statusDisplay, infoTooltip } = contract;
              const dateLabel = getContractCompletionDate(contract);
              return (
                <div key={idx} className='earnings-portal-table-row' style={{ gridTemplateColumns }}>
                  <div className='earnings-portal-table-cell'>{dateLabel ? getPrettyDate(dateLabel) : '-'}</div>
                  {title ? (
                    <a href={`/collaboration/${id}`} target='_blank' rel='noopener nofollow noreferrer' className='earnings-portal-table-cell'>
                      {contract.title || `Collaboration with ${brandName}`}
                    </a>
                  ) : (
                    <div className='earnings-portal-table-cell'>-</div>
                  )}
                  <div className='earnings-portal-table-cell'>{amountEarned ? getPrettyPriceDisplay(amountEarned) : '-'}</div>
                  <div className='earnings-portal-table-cell'>
                    {statusDisplay}
                    {infoTooltip && <Tooltip message={infoTooltip} getIconDiv={() => <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>} />}
                  </div>
                </div>
              );
            })}

            {contracts.length > 5 && !payoutsAreLoading && (
              <div className='earnings-portal-table-row' style={{ gridTemplateColumns: '1fr' }}>
                <div className='show-more' onClick={() => (hasMoreContracts ? setContractsVisible(contractsVisible + 5) : setContractsVisible(5))}>
                  {hasMoreContracts ? 'Show More' : 'Show Less'}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

EarningsPortalCollaborations.propTypes = {
  user: PropTypes.object.isRequired,
  payoutsAreLoading: PropTypes.bool.isRequired
};

export default EarningsPortalCollaborations;
